import React from 'react';

const BankDetails = ({ formData, handleInputChange, errors = {} }) => {
    const isBankDetailsRequired = formData.bank_name && formData.bank_name.trim().length > 0;

    return (
        <div className="form-section">
            <h3 className="section-heading">Bank Details</h3>
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">Bank Name</label>
                        <input
                            type="text"
                            name="bank_name"
                            placeholder="Enter Name of Bank"
                            value={formData.bank_name}
                            onChange={handleInputChange}
                            className="form-input"
                        />
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">
                            Account Number
                            {isBankDetailsRequired && <span style={{ color: 'red' }}> *</span>}
                        </label>
                        <input
                            type="text"
                            name="account_number"
                            placeholder="Enter account number"
                            value={formData.account_number}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    handleInputChange(e);
                                }
                            }}
                            className={`form-input${errors.account_number ? ' error' : ''}`}
                        />
                        {errors.account_number && <span className="error-message">{errors.account_number}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">
                            IFSC Code
                            {isBankDetailsRequired && <span style={{ color: 'red' }}> *</span>}
                        </label>
                        <input
                            type="text"
                            name="ifsc_code"
                            placeholder="Enter IFSC code"
                            value={formData.ifsc_code}
                            onChange={handleInputChange}
                            className={`form-input${errors.ifsc_code ? ' error' : ''}`}
                        />
                        {errors.ifsc_code && <span className="error-message">{errors.ifsc_code}</span>}
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label className="form-label">
                            Branch Name
                            {isBankDetailsRequired && <span style={{ color: 'red' }}> *</span>}
                        </label>
                        <input
                            type="text"
                            name="branch_name"
                            placeholder="Enter branch name"
                            value={formData.branch_name}
                            onChange={handleInputChange}
                            className={`form-input${errors.branch_name ? ' error' : ''}`}
                        />
                        {errors.branch_name && <span className="error-message">{errors.branch_name}</span>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BankDetails;
